/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-2016 Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React from 'react';
import Hours from './Hours';

const title = 'New User Registration';

function action(ctx, routeParams) {
  return {
    chunks: ['loyalty'],
    title,
    component: <Hours title={title} />,
    routeParams,
  };
}

export default action;



// WEBPACK FOOTER //
// ./src/routes/client/site/auth/hours/index.js